import { gql } from '@apollo/client';

/** mutation to create user comment for FR2052A rule */
export const CREATE_FFIEC031_USER_COMMENT = gql`
mutation createFFIEC031UserComment($input: CreateFFIEC031UserCommentInput) {
	createFFIEC031UserComment(input: $input)
}`;

/** mutation to update user comment for FR2052A rule */
export const UPDATE_FFIEC031_USER_COMMENT = gql`
mutation updateFFIEC031UserComment($input: UpdateFFIEC031UserCommentInput) {
	updateFFIEC031UserComment(input: $input)
}`;

export const DELETE_FFIEC031_USER_COMMENT = gql`
mutation deleteFFIEC031UserComment($input: DeleteFFIEC031UserCommentInput) {
	deleteFFIEC031UserComment(input: $input)
}`;

export const CREATE_CLASSIFY_AUDIT_LOGS_FOR_FFIEC031 = gql`
mutation createClassifyAuditLogForFFIEC031($input: ClassifyFFIEC031Input) {
	createClassifyAuditLogForFFIEC031(input: $input)
}`;
